// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import API from '@aws-amplify/api';
import Amplify from '@aws-amplify/api';
import Storage from '@aws-amplify/storage';
// import Amplify from 'aws-amplify';

export const environment = {
    production: false,

    helpScoutUrl: 'https://eguard.helpscoutdocs.com/',

    region: 'us-east-1',
    identityPoolId: 'us-east-1:b7d6924f-0837-4d81-9a15-6e65979ed40d',

    // this is for s3
    // this will be how many attempts before s3 calls it quits
    s3attempts: 3,

    // if you can the userpoolid remember to change the end of teh login token :)

    userPoolId: 'us-east-1_cYIIeo14O',
    clientId: '7f7f9b4iiq1antdsrbctefceq4',
    bucket: 'dev-eguard-documents',
    // stripeKey: 'pk_test_5Uc0Bb3bA2hzlASNUw8MSpSq',
    stripeKey: 'pk_test_y7imCudbrlg66ZDJQtnMWm5D00hkZlKw25',
    stripePublishableKey: 'pk_test_y7imCudbrlg66ZDJQtnMWm5D00hkZlKw25',
    loginKey: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_cYIIeo14O',
    sts_endpoint: 'sts.us-east-1.amazonaws.com/us-east-1_cYIIeo14O',

    commentLink: 'https://dev-api.eguard.us/comments/',
    casesLink: 'https://dev-api.eguard.us/cases/',
    casesNewLink:'https://dev-api.eguard.us/casesNew/',
    checkrLink: ' https://dev-api.eguard.us/checkr/',

    usersLink: 'https://dev-api.eguard.us/users/',

    stripeLink: 'https://dev-api.eguard.us/stripe/',
    organizationsLink: 'https://dev-api.eguard.us/organization/',
    formsLink: 'https://dev-api.eguard.us/forms/',
    todoLink: 'https://dev-api.eguard.us/todo/',
    alertsLink: 'https://dev-api.eguard.us/alerts/',

    // ocr = vision
    ocrLink: 'https://dev-api.eguard.us/vision/',

    // notification
    activitiesLink: 'https://dev-api.eguard.us/notification/',
    plaidWebhook: 'https://dev-api.eguard.us/plaid/plaid/webhooks',
    plaidKey: '8b735142953cb8719458723968fbac',
    plaidLink: 'https://dev-api.eguard.us/plaid/',

    zillow: 'https://dev-api.eguard.us/zillow/',

    loginBucketName: 'login-pictures-dev',

    // Calendar Event
    calendarEventsLink: 'https://dev-api.eguard.us/calendar/',
    snackBarErrorLength: 10000,

    reports: 'https://dev-api.eguard.us/reports/',
    preSign: 'https://dev-api.eguard.us/presign/',

    CASE_TRANSACTIONS: {
        TRANSACTIONS_BY_YEAR: 'https://dev-api.eguard.us/plaid/transactions/year/{year}/case/{case_id}/{account_id}',
        TRANSACTIONS_BY_DAY: 'https://dev-api.eguard.us/plaid/transactions/day/{days}/case/{case_id}/{account_id}'
    },
    PDF_DIFFERENCES_API: 'https://dev-api.eguard.us/vision/'
};

Amplify.configure({

    Storage: {
        Auth: {
            identityPoolId: environment.identityPoolId,
            region: environment.region,
            userPoolId: environment.userPoolId, //OPTIONAL - Amazon Cognito User Pool ID
            userPoolWebClientId:environment.clientId //OPTIONAL - Amazon Cognito Web Client ID
        },
        AWSS3: {
            bucket: 'dev-eguard-documents', //REQUIRED -  Amazon S3 bucket
            region: 'us-east-1', //OPTIONAL -  Amazon service region
        }
    },
    API: {
        endpoints: [
            {
                name: "casesLink",
                endpoint: "https://dev-api.eguard.us/cases/"
            },
            {
                name: "casesNewLink",
                endpoint: "https://dev-api.eguard.us/casesNew/"
            },
            {
                name: "commentLink",
                endpoint: "https://dev-api.eguard.us/comments/"
            },
            {
                name: "checkrLink",
                endpoint: "https://dev-api.eguard.us/checkr/"
            },
            {
                name: "usersLink",
                endpoint: "https://dev-api.eguard.us/users/"
            },
            {
                name: "stripeLink",
                endpoint: "https://dev-api.eguard.us/stripe/"
            },
            {
                name: "organizationsLink",
                endpoint: "https://dev-api.eguard.us/organization/"
            },
            {
                name: "formsLink",
                endpoint: "https://dev-api.eguard.us/forms/"
            },
            {
                name: "todoLink",
                endpoint: "https://dev-api.eguard.us/todo/"
            },
            {
                name: "alertsLink",
                endpoint: "https://dev-api.eguard.us/alerts/"
            },
            // ocr = vision
            {
                name: "ocrLink",
                endpoint: "https://dev-api.eguard.us/vision/"
            },
            {
                name: "activitiesLink",
                endpoint: "https://dev-api.eguard.us/notification/"
            },
            {
                name: "plaidWebhook",
                endpoint: "https://dev-api.eguard.us/plaid/plaid/webhooks"
            },
            {
                name: "plaidLink",
                endpoint: "https://dev-api.eguard.us/plaid/"
            },
            {
                name: "zillow",
                endpoint: "https://dev-api.eguard.us/zillow/"
            },
            // Calendar Event
            {
                name: "calendarEventsLink",
                endpoint: "https://dev-api.eguard.us/calendar/"
            },
            {
                name: "reports",
                endpoint: "https://dev-api.eguard.us/reports/"
            },
            {
                name: "preSign",
                endpoint: "https://dev-api.eguard.us/presign/"
            },
            {
                name: "PDF_DIFFERENCES_API",
                endpoint: "https://dev-api.eguard.us/vision/"
            },
            {
                name: "TRANSACTIONS_BY_YEAR",
                endpoint: "https://dev-api.eguard.us/plaid/transactions/year/{year}/case/{case_id}/{account_id}"
            },
            {
                name: "TRANSACTIONS_BY_DAY",
                endpoint: "https://dev-api.eguard.us/plaid/"
            },
            {
                name: "localForm",
                endpoint: "assets/forms/"
            },
            {
                name: "uploadLink",
                endpoint: "https://dev-eguard-documents.s3.amazonaws.com/"
            }]
    }
});
/*
// pgail enviroment
 export const environment = {
  production: false,

  region: 'us-east-1',
  identityPoolId: 'us-east-1:4e22c89f-ad33-400f-bfde-187e77475113',

  // this is for s3
  // this will be how many attempts before s3 calls it quits
  s3attempts: 3,

  // if you can the userpoolid remember to change the end of teh login token :)
  userPoolId: 'us-east-1_K4Gddm0bC',
  clientId: '322ig97fv8kojkr3vn40g8kbtr',
  bucket: 'dev-eguard-documents',
  stripeKey: 'pk_test_5Uc0Bb3bA2hzlASNUw8MSpSq',

  loginKey: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_oYHoYxO9i',
  sts_endpoint : 'sts.us-east-1.amazonaws.com/us-east-1_oYHoYxO9i',

  alertsLink: 'https://dev-api.eguard.us/alerts/',
  commentLink: 'https://6nv7ekr95d.execute-api.us-east-1.amazonaws.com/pgali/',
  casesLink: 'https://bnaqslsgs4.execute-api.us-east-1.amazonaws.com/pgali/',
  usersLink: 'https://jokwqy6obd.execute-api.us-east-1.amazonaws.com/pgali/',
  stripeLink: 'https://75sw4wqrn5.execute-api.us-east-1.amazonaws.com/pgali/',
  organizationsLink: 'https://ig41du27wf.execute-api.us-east-1.amazonaws.com/pgali/',
  formsLink: 'https://dayto9reib.execute-api.us-east-1.amazonaws.com/pgali/',
  todoLink: 'https://wd817pzc07.execute-api.us-east-1.amazonaws.com/dev/',

  // ocr = vision
  ocrLink: 'https://gmtujael6l.execute-api.us-east-1.amazonaws.com/dev/',

  // notification
  activitiesLink: 'https://u8du5z0w78.execute-api.us-east-1.amazonaws.com/pgali/',
  plaidWebhook: 'https://w0d0i1kf25.execute-api.us-east-1.amazonaws.com/pgali/plaid/webhooks',
  plaidKey: '92f9e2fd096c803bdae2004cc49058',
  plaidLink: 'https://w0d0i1kf25.execute-api.us-east-1.amazonaws.com/pgali/',

  loginBucketName: 'login-pictures-dev',

  // Calendar Event
  calendarEventsLink: 'https://u1h5um8so8.execute-api.us-east-1.amazonaws.com/dev/',
  snackBarErrorLength:10000,
  reports: 'https://zndwnnvflk.execute-api.us-east-1.amazonaws.com/pgali/',
  // Reports API's
  REPORTS: {
    CASE_STATUSES_API : 'https://i1w739bnel.execute-api.us-east-1.amazonaws.com/hmhase/organizations/8951fee6-468b-4b35-96d1-ff1b6932836f/reports/Statuses',
    CASE_TYPES_API : 'https://i1w739bnel.execute-api.us-east-1.amazonaws.com/hmhase/organizations/8951fee6-468b-4b35-96d1-ff1b6932836f/reports/CaseType',
    PAID_CASES_API : 'https://i1w739bnel.execute-api.us-east-1.amazonaws.com/hmhase/organizations/8951fee6-468b-4b35-96d1-ff1b6932836f/reports/IsPaid',
    ACTIVE_CASES_API : 'https://i1w739bnel.execute-api.us-east-1.amazonaws.com/hmhase/organizations/8951fee6-468b-4b35-96d1-ff1b6932836f/reports/IsActive',
    CALENDAR_CASES_API : 'https://i1w739bnel.execute-api.us-east-1.amazonaws.com/hmhase/organizations/8951fee6-468b-4b35-96d1-ff1b6932836f/reports/CalendarCases',
    CASE_AGE_IN_DAYS_API : 'https://i1w739bnel.execute-api.us-east-1.amazonaws.com/hmhase/organizations/8951fee6-468b-4b35-96d1-ff1b6932836f/reports/CasesAgeInDays'
  },
  preSign: 'https://hr0vnnx2uh.execute-api.us-east-1.amazonaws.com/dev/',

  CASE_TRANSACTIONS : {
    TRANSACTIONS_BY_YEAR : 'https://dev-api.eguard.us/plaid/transactions/year/{year}/case/{case_id}/{account_id}' ,
    TRANSACTIONS_BY_DAY : 'https://dev-api.eguard.us/plaid/transactions/day/{days}/case/{case_id}/{account_id}'
  } ,
  PDF_DIFFERENCES_API : 'https://q997h17oyh.execute-api.us-east-1.amazonaws.com/dev/organizations/ORG_ID/cases/CASE_ID/file/FORM_ID'
};
*/



// WEBPACK FOOTER //
// ./src/environments/environment.ts